
export const corebasic = {

  country: {
    service: {
      name: 'country',
      title: 'Country',
    }
  },

  currency: {
    service: {
      name: 'currency',
      title: 'Currency',
    }
  },

  dashtab: {
    service: {
      name: 'dashtab',
      title: 'Dash Tabs'
    },
    create: false
  },

  dashtype: {
    service: {
      name: 'dashtype',
      title: 'Dash Type',
    }
  },

  devicetype: {
    service:{
      name:'devicetype',
      title:'Device Type',
    }
  },

  idtype: {
    service: {
      name: 'idtype',
      title: 'ID Type',
    }
  },

  linktype: {
    service: {
      name: 'linktype',
      title: 'Link Type',
    }
  },

  linkstate: {
    service: {
      name: 'linkstate',
      title: 'Link State',
    }
  },

  messagetype: {
    service: {
      name: 'messagetype',
      title: 'Message Type',
    }
  },

  compliancetype: {
    service: {
      name: 'compliancetype',
      title: 'Compliance Type',
    }
  },

  servicetype: {
    service: {
      name: 'servicetype',
      title: 'Service Type',
    }
  },

  subscriptionstate: {
    service: {
      name: 'subscriptionstate',
      title: 'Subscription State',
    }
  },


  requeststatus: {
    service: {
      name: 'requeststatus',
      title: 'Request Status',
    }
  },

  messagemode: {
    service: {
      name: 'messagemode',
      title: 'Message Mode',
    }
  },
  
  messagechannel: {
    service: {
      name: 'messagechannel',
      title: 'Message Channel',
    }
  },

  orgtype: {
    service: {
      name: 'orgtype',
      title: 'Organization Type',
    }
  },

  region: {
    service: {
      name: 'region',
      title: 'Region',
    }
  },

};
